import "antd/es/spin/style";
import _Spin from "antd/es/spin";
import "antd/es/tree-select/style";
import _TreeSelect from "antd/es/tree-select";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["radioType", "renderFormItem", "mode", "light", "render"],
    _excluded2 = ["onSearch", "onClear", "onChange", "onBlur", "showSearch", "autoClearSearchValue", "treeData", "searchValue"];
import React, { useContext, useMemo, useImperativeHandle, useRef } from 'react';
import classNames from 'classnames';
import { ObjToMap, proFieldParsingText, useFieldFetchData } from '../Select';
import useMergedState from "rc-util/es/hooks/useMergedState";
/**
 * Tree select
 * A function that returns a React component.
 * @param ref
 */

var FieldTreeSelect = function FieldTreeSelect(_ref, ref) {
  var radioType = _ref.radioType,
      renderFormItem = _ref.renderFormItem,
      mode = _ref.mode,
      light = _ref.light,
      render = _ref.render,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var layoutClassName = getPrefixCls('pro-field-tree-select');
  var coreStyleClassName = getPrefixCls('pro-core-field-label');
  var treeSelectRef = useRef(null);

  var _ref2 = rest.fieldProps || {},
      onSearch = _ref2.onSearch,
      _onClear = _ref2.onClear,
      propsOnChange = _ref2.onChange,
      _onBlur = _ref2.onBlur,
      showSearch = _ref2.showSearch,
      autoClearSearchValue = _ref2.autoClearSearchValue,
      treeData = _ref2.treeData,
      propsSearchValue = _ref2.searchValue,
      fieldProps = _objectWithoutProperties(_ref2, _excluded2);

  var _useFieldFetchData = useFieldFetchData(_objectSpread(_objectSpread({}, rest), {}, {
    defaultKeyWords: propsSearchValue
  })),
      _useFieldFetchData2 = _slicedToArray(_useFieldFetchData, 3),
      loading = _useFieldFetchData2[0],
      options = _useFieldFetchData2[1],
      _fetchData = _useFieldFetchData2[2];

  var _useMergedState = useMergedState('', {
    onChange: onSearch,
    value: propsSearchValue
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      searchValue = _useMergedState2[0],
      setSearchValue = _useMergedState2[1];

  useImperativeHandle(ref, function () {
    return _objectSpread(_objectSpread({}, treeSelectRef.current || {}), {}, {
      fetchData: function fetchData() {
        return _fetchData();
      }
    });
  });
  var optionsValueEnum = useMemo(function () {
    if (mode !== 'read') return;
    /**
     * Support TreeSelect fieldNames
     * @see https://ant.design/components/tree-select-cn
     */

    var _ref3 = (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.fieldNames) || {},
        _ref3$value = _ref3.value,
        valuePropsName = _ref3$value === void 0 ? 'value' : _ref3$value,
        _ref3$label = _ref3.label,
        labelPropsName = _ref3$label === void 0 ? 'label' : _ref3$label,
        _ref3$children = _ref3.children,
        childrenPropsName = _ref3$children === void 0 ? 'children' : _ref3$children;

    var valuesMap = new Map();

    var traverseOptions = function traverseOptions(_options) {
      if (!(_options === null || _options === void 0 ? void 0 : _options.length)) {
        return valuesMap;
      }

      var length = _options.length;
      var i = 0;

      while (i < length) {
        var cur = _options[i++];
        valuesMap.set(cur[valuePropsName], cur[labelPropsName]);
        traverseOptions(cur[childrenPropsName]);
      }

      return valuesMap;
    };

    return traverseOptions(options);
  }, [fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.fieldNames, mode, options]);

  var onChange = function onChange(value, optionList, extra) {
    // 将搜索框置空 和 antd 行为保持一致
    if (showSearch && autoClearSearchValue) {
      _fetchData('');

      setSearchValue('');
    }

    propsOnChange === null || propsOnChange === void 0 ? void 0 : propsOnChange(value, optionList, extra);
  };

  if (mode === 'read') {
    var dom = /*#__PURE__*/React.createElement(React.Fragment, null, proFieldParsingText(rest.text, ObjToMap(rest.valueEnum || optionsValueEnum)));

    if (render) {
      return render(rest.text, _objectSpread({
        mode: mode
      }, fieldProps), dom) || null;
    }

    return dom;
  }

  if (mode === 'edit') {
    var _fieldProps$value;

    var valuesLength = Array.isArray(fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.value) ? fieldProps === null || fieldProps === void 0 ? void 0 : (_fieldProps$value = fieldProps.value) === null || _fieldProps$value === void 0 ? void 0 : _fieldProps$value.length : 0;

    var _dom = /*#__PURE__*/React.createElement(_Spin, {
      spinning: loading
    }, /*#__PURE__*/React.createElement(_TreeSelect, _extends({
      ref: treeSelectRef,
      dropdownMatchSelectWidth: !light,
      tagRender: light ? function (item) {
        var _fieldProps$value2;

        if (valuesLength < 2) return /*#__PURE__*/React.createElement(React.Fragment, null, item.label);
        /**
         * 性能不好，等我给 antd 提个issue
         */

        var itemIndex = fieldProps === null || fieldProps === void 0 ? void 0 : (_fieldProps$value2 = fieldProps.value) === null || _fieldProps$value2 === void 0 ? void 0 : _fieldProps$value2.findIndex(function (v) {
          return v === item.value || v.value === item.value;
        });
        return /*#__PURE__*/React.createElement(React.Fragment, null, item.label, " ", itemIndex < valuesLength - 1 ? ',' : '');
      } : undefined
    }, fieldProps, {
      bordered: !light,
      treeData: options || treeData,
      showSearch: showSearch,
      style: _objectSpread({
        minWidth: 60
      }, fieldProps.style),
      searchValue: searchValue,
      autoClearSearchValue: autoClearSearchValue,
      onClear: function onClear() {
        _onClear === null || _onClear === void 0 ? void 0 : _onClear();

        _fetchData('');

        if (showSearch) {
          setSearchValue('');
        }
      },
      onChange: onChange,
      onSearch: function onSearch(value) {
        _fetchData(value);

        setSearchValue(value);
      },
      onBlur: function onBlur(event) {
        setSearchValue('');

        _fetchData('');

        _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(event);
      },
      className: classNames(fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.className, layoutClassName, _defineProperty({}, "".concat(coreStyleClassName, "-active"), (fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.value) && light))
    })));

    if (renderFormItem) {
      return renderFormItem(rest.text, _objectSpread({
        mode: mode
      }, fieldProps), _dom) || null;
    }

    return _dom;
  }

  return null;
};

export default /*#__PURE__*/React.forwardRef(FieldTreeSelect);